import { useTranslation } from 'react-i18next'
import { Col, Row } from 'react-bootstrap'
import { User } from 'graphqlAPI'
import BasePopover from 'components/monitoring/components/BasePopover'
import { prefixColumns } from './constants'

export function CoursesCount({ value }: { value: User | undefined }) {
  const { t } = useTranslation()

  const coursesCount = value?.coursesCount || 0
  const externalCoursesCount = value?.externalCoursesCount || 0
  const total = coursesCount + externalCoursesCount

  const labels = [
    { label: t('monitoring.courses.title'), value: coursesCount },
    {
      label: t('monitoring.externalCourses.title'),
      value: externalCoursesCount,
    },
  ]

  return (
    <BasePopover
      id={`courses_count-${value?.id}`}
      component="span"
      popoverContent={
        <Row>
          {labels.map(({ label, value: count }, index) => (
            <Col xs={12} key={index}>
              <Row>
                <Col xs={6}>{label}</Col>
                <Col xs={6}>{count}</Col>
              </Row>
            </Col>
          ))}
        </Row>
      }
    >
      <span>{t(`${prefixColumns}.courses`, { count: total })}</span>
    </BasePopover>
  )
}
